// extracted by mini-css-extract-plugin
export default {"video":"homePage_video__-yS9S","contactsLocation":"homePage_contactsLocation__ArgJY"};